import { ParamsWithPagination } from '@/types/api';

import { LogosFilters } from '../types';

export const logosQueryKeys = {
  all: ['logos'] as const,
  byId: (id: string) => [...logosQueryKeys.all, { id }] as const,
  lists: () => [...logosQueryKeys.all, 'list'] as const,
  list: (params?: ParamsWithPagination<LogosFilters>) => [...logosQueryKeys.lists(), params],
  /**
   * Kept apart from `list`: the paged filter query caches an array of pages, the one-page
   * callers cache a single response. Sharing a key would hand one shape to the other.
   */
  infiniteLists: () => [...logosQueryKeys.all, 'infinite-list'] as const,
  infiniteList: (params?: ParamsWithPagination<LogosFilters>) => [
    ...logosQueryKeys.infiniteLists(),
    params,
  ],
  /** Sorted, so the dropdown and the applied-filters summary share one request. */
  selected: (ids: string[]) => [...logosQueryKeys.all, 'selected', [...ids].sort()] as const,
};
